import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa2db802"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "insights" };
import { useCampaignsInsights } from '../composables';
import EndOfLifeCard from './EndOfLifeCard.vue';
import CategoryActionCard from './CategoryActionCard.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'InsightsCardsContainer',
    setup(__props) {
        const { insights } = useCampaignsInsights();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(insights).endOfLifeActions, (endOfLifeInsight) => {
                    return (_openBlock(), _createBlock(EndOfLifeCard, {
                        key: endOfLifeInsight.id,
                        insight: endOfLifeInsight
                    }, null, 8, ["insight"]));
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(insights).categoryActions, (categoryInsight) => {
                    return (_openBlock(), _createBlock(CategoryActionCard, {
                        key: categoryInsight.categoryId,
                        insight: categoryInsight
                    }, null, 8, ["insight"]));
                }), 128))
            ]));
        };
    }
});
